export function ApiPlayground() {
  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">🌐 API Playground</h1>
        <p className="page-subtitle">
          Test API client features and interceptors
        </p>
      </div>

      <div className="card">
        <div className="card-header">
          <div className="card-title">
            <span className="card-icon">🚧</span>
            Coming Soon
          </div>
          <span className="card-badge info">In Development</span>
        </div>
        <div style={{ textAlign: "center", padding: "48px 0", color: "var(--text-muted)" }}>
          <div style={{ fontSize: "4rem", marginBottom: 16 }}>🏗️</div>
          <p style={{ fontSize: "1.1rem", marginBottom: 8 }}>
            API Playground is under construction
          </p>
          <p style={{ fontSize: "0.9rem" }}>
            This section will allow you to test API calls, configure interceptors,
            and see request/response details.
          </p>
        </div>
      </div>

      <div className="card mt-lg">
        <div className="card-header">
          <div className="card-title">
            <span className="card-icon">💻</span>
            Planned Features
          </div>
        </div>
        <div className="code-block">
{`// Planned API Playground Features:

✓ Make HTTP requests with the SDK API client
✓ Configure request/response interceptors
✓ View request headers and authentication tokens
✓ Test error handling scenarios
✓ Mock API responses for testing
✓ Export cURL commands`}
        </div>
      </div>
    </div>
  );
}
